import e from "@dialpad/dialtone-tokens/layered/themes/tokens-135-colors.css?inline";
//#region themes/135.js
var t = { brand: {
	css: e,
	name: "135"
} };
//#endregion
export { t as default };
